import { CSSProperties, FC, ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import classes from './style.module.scss';
export enum EPANEL_DIRECTION {
  LEFT_TO_RIGHT = 'left_to_right',
  RIGHT_TO_LEFT = 'right_to_left',
}
type IpanelSlideProps = {
  children: ReactNode;
  direction?: EPANEL_DIRECTION;
  open?: boolean;
  style?: CSSProperties;
  btnStyle?: CSSProperties;
  onClose?: () => void;
};

const PanelSlider: FC<IpanelSlideProps> = ({
  children,
  direction = EPANEL_DIRECTION.RIGHT_TO_LEFT,
  open = false,
  style = {},
  btnStyle = {},
  onClose,
}: IpanelSlideProps) => {
  return (
    <>
      {open && <div className={classes.panesliderOverlay}></div>}
      <div
        className={
          open
            ? classes.panelSlide + ' ' + classes.open
            : classes.panelSlide + ' ' + classes.close
        }
        data-direction={direction}
        style={style}
      >
        <span className={classes.closebtn} style={btnStyle}>
          <FontAwesomeIcon onClick={onClose && onClose} icon={faClose} />
        </span>
        {children}
      </div>
    </>
  );
};
export default PanelSlider;
